import { Injectable } from "@angular/core";

import { combineLatest, Observable } from "rxjs";
import { map } from "rxjs/operators";

import { DffError } from "@dffedb/util";
import { ValgtInstallationService } from "@e-forsyning/common/valgt-installation";

import { StamoplysningerViewModel } from "./model/stamoplysninger.view-model";
import { StamoplysningerFormBuilder } from "./stamoplysninger-form-builder";

@Injectable({ providedIn: "root" })
export class StamoplysningerSandbox {
    constructor(private readonly valgtInstallationService: ValgtInstallationService) {}

    public hentViewModel(): Observable<StamoplysningerViewModel> {
        const installationsoplysninger$ = this.valgtInstallationService.hentInstallationsoplysninger();

        return combineLatest([installationsoplysninger$]).pipe(
            map(([installationsoplysninger]) => {
                const formGroup = StamoplysningerFormBuilder.opretForm(installationsoplysninger);
                return {
                    installationsoplysninger,
                    formGroup
                };
            })
        );
    }

    public async redigerTelefonnr(nytTelefonnr: string): Promise<void> {
        try {
            await this.valgtInstallationService.redigerTelefonnr(nytTelefonnr);
        } catch (e) {
            throw new DffError(e.message, { friendlyMessage: "Fejl i rediger telefonnr.", innerError: e });
        }
    }

    public async redigerBeboeremail(nyBeboeremail: string): Promise<void> {
        try {
            await this.valgtInstallationService.redigerBeboeremail(nyBeboeremail);
        } catch (e) {
            throw new DffError(e.message, { friendlyMessage: "Fejl i rediger email.", innerError: e });
        }
    }
}
